import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LeadsStatusesFetchContext from '@/modules/leads_statuses/contexts/LeadsStatusesFetchContext';
import Paper from '@/modules/common/components/Paper';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { actionDockSetExpandLeadsStatuses } from '@/modules/application/actions/dock';
import { actionSetLeadsStatusesFetchIds } from '@/modules/application/actions/leads_statuses/fetch';
import Fetch from './Fetch';
import Data from './Data/Data';
import '../../styles/LeadsStatusesFetch.scss';

const initialValuesFilter = {
};

const initialErrors = {
    ids: '',
};

const mapValuesFilter = {
};

function isFiltered(urlSearchParams) {
    return (
        Object.entries(mapValuesFilter).some((element) => urlSearchParams.get(element[1]))
    );
}

let abortController;

const LeadsStatusesFetch = (props) => {
    const breadcrumbs = [
        {name: 'Статусы'},
        {name: 'Выгрузка'},
    ];

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [errors, setErrors] = useState(initialErrors);

    const _isFiltered = () => Boolean(isFiltered(props.router.urlSearchParams));

    const fetch = () => {
        if (abortController) {
            abortController.abort();
        }
        abortController = new AbortController();
        setLoading(true);

        props.fetch.post(
            `/api/leads_statuses/fetch/?${props.router.urlSearchParams.toString()}`, {ids: props.ids}, abortController
        ).then(({ok, data}) => {
            if (ok) {
                setData(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.ids = (data.ids) ? data.ids[0] : '';
                setErrors(_errors);
            }
            setLoading(false);
        }).catch((error) => {
            setData(null);
            if (error.name !== 'AbortError') {
                setLoading(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    useEffect(() => {
        props.dockSetExpandLeadsStatuses(true);
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (props.ids.length > 0) {
            let page = parseInt(props.router.urlSearchParams.get('page'));
            if (!isNaN(page)) {
                // noinspection JSCheckFunctionSignatures
                props.router.urlSearchParams.set('page', page);
            }
            fetch();
        }
    }, [props.history.location.search]);

    const handleSubmitFetch = (event) => {
        event.preventDefault();
        if (!data || !data.results.length) {
            props.history.push({search: ''});
        }
    };

    return  (
        <LeadsStatusesFetchContext.Provider value={{
            loading: loading,
            data: data, setData: setData,
            isFiltered: _isFiltered(),
            ids: props.ids, setIds: props.setIds,
            errors: errors, setErrors: setErrors,
        }}>
            <Content id="leads_statuses-fetch">
                <ContentHeader breadcrumbs={breadcrumbs}/>
                <ContentBody><Paper>
                    {(loading)
                        ? <Spinner/>
                        : null
                    }
                    <Fetch onSubmit={handleSubmitFetch}/>
                    <Data/>
                </Paper></ContentBody>
            </Content>
        </LeadsStatusesFetchContext.Provider>
    );
};

let Component = LeadsStatusesFetch;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        ids: state.leads_statuses_fetch.ids,
    }),
    (dispatch) => ({
        dockSetExpandLeadsStatuses: bindActionCreators(actionDockSetExpandLeadsStatuses, dispatch),
        setIds: bindActionCreators(actionSetLeadsStatusesFetchIds, dispatch),
    })
)(Component);
